import { ImpactType } from './units';

export const impactTypeToFriendlyLabel: Record<ImpactType, string> = {
  [ImpactType.TREES]: 'Reforestation',
  [ImpactType.CARBON_OFFSETS]: 'Carbon avoidance',
  [ImpactType.CARBON_REMOVAL]: 'Carbon removal',
  [ImpactType.HABITAT_RESTORATION]: 'Habitat restoration',
};
